import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import * as url from "../../api/uri_helper";

const QrCodeGenerator = ({ siteid, appid, computername,isshow }) => {         
    const [data, setData] = useState('');

    useEffect(() => {        
        //binded props with base url
        const qrUrl = `${url.TEKAGUI}/support?siteId=${siteid}&appID=${appid}&desktopname=${computername}`;
        setData(qrUrl); // Set the data that will be used to generate the QR code
    }, [siteid, appid, computername]);

    return (
        <>
            <div className="">
                {data && typeof data === 'string' ? (
                    <div className="qrcodesvg">
                        <QRCodeSVG
                            value={data} // Ensure this is a valid string
                            size={isshow? 350 : 150}
                            level="H"
                            fgColor="#b97a57"
                            bgColor="#FFFFFF"
                        />
                    </div>
                ) : (
                    <div>Loading QR Code...</div>
                )}


            </div>
        </>
    );
};

export default QrCodeGenerator;


